import React from 'react';
import styled from 'styled-components';
import AnswerBox from '@catalogo/ui-americanas-mobile-questions-and-answers-list/src/components/answer-box';
import Clock from '@catalogo/ui-americanas-desktop-svg/clock.svg';

const QuestionBox = ({ question }) => (
  <Wrapper>
    <Question>{question.question}</Question>
    <Date>{question.createdAt}</Date>
    <StatusBox>
      {question.answer.text ? (
        <AnswerBox answer={question.answer} />
      ) : (
        <>
          <Clock height="16" width="16" fill="#999" />
          <Status>aguardando resposta</Status>
        </>
      )}
    </StatusBox>
  </Wrapper>
);

export default QuestionBox;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.grey.light};
  border-radius: 3px;
  padding: 13px;
  margin-top: 10px;
`;

const Question = styled.h4`
  font-weight: bold;
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const Date = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.grey.light};
  font-size: ${({ theme }) => theme.fontSize.xs};
  margin-top: 5px;
  color: #838383;
`;

const Status = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.grey.medium};
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding-left: 8px;
`;

const StatusBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
`;
